import React from 'react';

import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { DetailsGrid } from '@indigo-ag/component-module';
import { CropCashFlow } from '@indigo-ag/schema';
import i18next from 'i18next';
import { currency, parseNumberToLocale, parseNumberToLocaleInMillions, parsePercentToLocale } from 'shared';

interface Props {
  cropCashFlowItem: CropCashFlow;
}

export const CropCashFlowDetailsGrid = ({
  cropCashFlowItem: {
    ownedLand,
    totalLand,
    leasedLand,
    productionCost,
    leaseCost,
    indigoProductivity,
    percentOwnedLand,
    grossRevenue
  }
}: Props) => {
  const emptyValue = '-';

  return (
    <DetailsGrid
      columnWidth={300}
      items={[
        {
          label: i18next.t('cropCashFlowGrid_OwnedLand'),
          value: ownedLand ? parseNumberToLocale(ownedLand) ?? emptyValue : emptyValue
        },
        {
          label: i18next.t('cropCashFlowGrid_LeasedLand'),
          value: leasedLand ? parseNumberToLocale(leasedLand) ?? emptyValue : emptyValue
        },
        { label: i18next.t('cropCashFlowGrid_TotalLand'), value: parseNumberToLocale(totalLand) ?? emptyValue },
        {
          label: i18next.t('cropCashFlowGrid_PercentOwnedLand'),
          labelIcon: faInfoCircle,
          description: i18next.t('calculationsTooltip_percentOwnedLand'),
          value: percentOwnedLand ? parsePercentToLocale(percentOwnedLand) : emptyValue
        },
        {
          label: i18next.t('cropCashFlowGrid_ProductionCost'),
          labelIcon: faInfoCircle,
          description: i18next.t('calculationsTooltip_productionCost'),
          value: productionCost ? currency.formatLocaleCurrency(productionCost, 'BRL') : emptyValue
        },
        {
          label: i18next.t('cropCashFlowGrid_LeaseCost'),
          labelIcon: faInfoCircle,
          description: i18next.t('calculationsTooltip_leaseCost'),
          value: leaseCost ? currency.formatLocaleCurrency(leaseCost, 'BRL') : emptyValue
        },
        {
          label: i18next.t('cropCashFlowGrid_IndigoProductivity'),
          value: indigoProductivity ? parseNumberToLocale(indigoProductivity, 'Ha') ?? emptyValue : emptyValue
        },
        {
          label: `${i18next.t('cropCashFlowGrid_GrossRevenue')} (M)`,
          labelIcon: faInfoCircle,
          description: i18next.t('calculationsTooltip_grossRevenue'),
          value: grossRevenue ? parseNumberToLocaleInMillions(grossRevenue) : emptyValue
        }
      ]}
    />
  );
};
